import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

// Partial update — send only the keys that changed so a name-only edit never
// clobbers disabled_at (the BE PATCH accepts any subset of
// {name, max_payout_amount_cents, disabled}).
export const updatePromotion = async (promotionId, changes = {}) => {
  const headers = await getAuthHeaders();

  const body = {};
  if (changes.name !== undefined) body.name = changes.name;
  if (changes.maxPayoutAmountCents !== undefined) {
    body.max_payout_amount_cents = changes.maxPayoutAmountCents;
  }
  if (changes.disabled !== undefined) body.disabled = changes.disabled;

  const response = await tempMeeApi.patch(
    `/payment/admin/promotion-campaigns/${promotionId}`,
    body,
    { headers },
  );

  return response.data;
};
